import {action, observable, runInAction} from 'mobx';
import {SharingState} from '../sharing-state/sharing.state';
import {
    ISharingService,
    ISharingParams,
    ISignedData,
    ISharingModeActions
} from '../../../services/ts-sharing-service/contracts';

export default class HistoryResourcesController {
    @observable sharingModeActions: ISharingModeActions[] = [];

    constructor(
        private sharingState: SharingState,
        private sharingService: ISharingService
    ) {
        this.init();
    }

    @action
    private init() {
        this.sharingModeActions = this.sharingService.getShareModeActions();
    }

    public findSelectedResource(resource: any) {
        const location = resource._sharingLocation;

        return [...this.sharingState.imagesWidgets].find((widget: any) => {
            const urlMatch = widget.url === resource.url;
            const locationMatch = widget._sharingLocation === location;

            return urlMatch && locationMatch;
        });
    }

    @action
    private _loadSignedData(resource: any) {
        const selectedResource = this.findSelectedResource(resource);

        if (selectedResource) {
            const indexToRemove = this.sharingState.imagesWidgets.findIndex(
                (r) => r.url === selectedResource.url && r._sharingLocation === selectedResource._sharingLocation
            );

            runInAction(() => {
                this.sharingState.imagesWidgets.splice(indexToRemove, 1);
            });

            return;
        }

        const sharingParams: ISharingParams = {
            _id: resource._id,
            url: resource.url,
            type: 'url' as const
        };

        // Create a separate object for internal state tracking
        const newResource = {
            inProgress: true,
            ...sharingParams,
            _sharingLocation: resource._sharingLocation // Preserve location identifier
        };

        this.sharingState.imagesWidgets.push(newResource);

        Promise.resolve().then(() => {
            const servicePromise = this.sharingService.getSignedDataForImageSharing(sharingParams);

            return servicePromise
                .then((signedData: ISignedData) => {
                    runInAction(() => {
                        const patch = {
                            inProgress: false,
                            signedData: signedData
                        };

                        const index = [...this.sharingState.imagesWidgets].findIndex(
                            (r: any) => r.url === newResource.url && r._sharingLocation === newResource._sharingLocation
                        );
                        this.sharingState.imagesWidgets[index] = {...newResource, ...patch};
                    });
                })
                .catch(() => {
                    runInAction(() => {
                        this.sharingState.imagesWidgets.splice(this.sharingState.imagesWidgets.indexOf(newResource), 1);
                    });
                });
        });
    }

    @action
    public onShareClick = (e: React.MouseEvent, resource: any) => {
        e.stopPropagation();

        // _loadSignedData handles both opening (if not found) and closing (if found)
        this._loadSignedData(resource);
    };

    isSelectResourceReady = (data: any) => {
        const resource = this.findSelectedResource(data);
        return !!(resource && resource.inProgress === false);
    };
}
